import service from '../utils/request'

export function login(data) {
  return service({
    url: '/zlwc/signup',
    method: 'POST',
    data: data,
  })
}

export function getWXConfig(params) {
  return service({
    url: '/wechat/getSignPackage',
    method: 'get',
    params
  })
}

export function GETWXLOGIINFOU(params) {
  return service({
    url: '/wechat/userinfo/detail',
    method: 'get',
    params
  })
}